import React from 'react';
import { Link } from 'react-router-dom';

// End of Service Benefits Blog Post Content
export const EndOfServiceContent = () => (
  <>
    <p className="text-lg leading-relaxed">
      مكافأة نهاية الخدمة هي حق مالي يكفله نظام العمل السعودي لكل عامل عند انتهاء علاقة العمل. ليست مكافأة اختيارية أو قابلة للتفاوض — بل هي <strong>التزام نظامي على صاحب العمل</strong> بموجب المادة 84 من نظام العمل.
    </p>

    <p>
      سواء كنت موظفاً تريد معرفة حقوقك، أو صاحب عمل تريد حساب المستحقات بشكل صحيح، أو مدير موارد بشرية يتعامل مع حالات إنهاء خدمة — هذا الدليل يشرح لك كل ما تحتاج معرفته بالتفصيل مع أمثلة عملية.
    </p>

    <h2>ما هي مكافأة نهاية الخدمة؟</h2>
    <p>
      مكافأة نهاية الخدمة هي مبلغ مالي يُدفع للعامل عند انتهاء عقد العمل، يُحسب على أساس آخر أجر كان يتقاضاه العامل ومدة خدمته. تهدف إلى توفير أمان مالي للعامل بعد انتهاء علاقته الوظيفية.
    </p>

    <blockquote>
      المادة 84: "إذا انتهت علاقة العمل وجب على صاحب العمل أن يدفع إلى العامل مكافأة عن مدة خدمته، تُحسب على أساس أجر نصف شهر عن كل سنة من السنوات الخمس الأولى، وأجر شهر عن كل سنة من السنوات التالية، ويُتخذ الأجر الأخير أساساً لحساب المكافأة."
    </blockquote>

    <h2>كيف تُحسب المكافأة؟ (المادة 84)</h2>
    <p>المعادلة الأساسية لحساب المكافأة تعتمد على تقسيم سنوات الخدمة إلى فترتين:</p>
    <p><strong>السنوات الخمس الأولى:</strong> نصف شهر (أجر 15 يوماً) عن كل سنة</p>
    <p><strong>ما بعد السنوات الخمس:</strong> شهر كامل (أجر 30 يوماً) عن كل سنة</p>

    <h3>مثال عملي: موظف عمل 8 سنوات براتب 10,000 ريال</h3>
    <div className="overflow-x-auto">
      <table>
        <thead>
          <tr>
            <th>الفترة</th>
            <th>المعادلة</th>
            <th>المبلغ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>أول 5 سنوات</td>
            <td>(10,000 ÷ 2) × 5</td>
            <td><strong>25,000 ريال</strong></td>
          </tr>
          <tr>
            <td>3 سنوات التالية</td>
            <td>10,000 × 3</td>
            <td><strong>30,000 ريال</strong></td>
          </tr>
          <tr className="bg-[#111111]/10">
            <td><strong>الإجمالي</strong></td>
            <td>25,000 + 30,000</td>
            <td><strong>55,000 ريال</strong></td>
          </tr>
        </tbody>
      </table>
    </div>

    <h2>المكافأة عند الاستقالة (المادة 85)</h2>
    <p>إذا كان سبب انتهاء العلاقة هو استقالة العامل، تختلف نسبة المكافأة المستحقة حسب مدة الخدمة:</p>
    <p><strong>أقل من سنتين:</strong> لا يستحق العامل أي مكافأة.</p>
    <p><strong>من سنتين إلى 5 سنوات:</strong> يستحق ثلث المكافأة.</p>
    <p><strong>من 5 سنوات إلى 10 سنوات:</strong> يستحق ثلثي المكافأة.</p>
    <p><strong>أكثر من 10 سنوات:</strong> يستحق المكافأة كاملة.</p>

    <h3>مثال: موظف استقال بعد 7 سنوات براتب 8,000 ريال</h3>
    <p>
      المكافأة الكاملة = (4,000 × 5) + (8,000 × 2) = 36,000 ريال. <strong>لكن بما أنه استقال بعد 7 سنوات (بين 5 و10)، يستحق ثلثي المكافأة = 36,000 × ⅔ = 24,000 ريال.</strong>
    </p>

    <h2>حالات خاصة</h2>

    <h3>استقالة المرأة بسبب الزواج أو الإنجاب (المادة 87)</h3>
    <p>
      إذا انتهى عقد عمل المرأة خلال 6 أشهر من زواجها أو خلال 3 أشهر من تاريخ الوضع، فإنها تستحق المكافأة كاملة بغض النظر عن مدة الخدمة.
    </p>

    <h3>الاستقالة بسبب القوة القاهرة (المادة 87)</h3>
    <p>إذا ترك العامل العمل نتيجة قوة قاهرة خارجة عن إرادته، يستحق المكافأة كاملة.</p>

    <h3>حالات عدم استحقاق المكافأة (المادة 80)</h3>
    <p>
      يحق لصاحب العمل فصل العامل دون مكافأة أو تعويض في حالات محددة، منها: الاعتداء على صاحب العمل، الإخلال الجسيم بالتزامات العقد، الغياب دون سبب مشروع أكثر من 30 يوماً خلال السنة أو 15 يوماً متتالية، وإفشاء الأسرار التجارية.
    </p>

    <h2>ما هو الأجر المعتمد في حساب المكافأة؟</h2>
    <p>
      الأجر المعتمد هو <strong>الأجر الفعلي الأخير</strong> الذي كان يتقاضاه العامل، ويشمل: الراتب الأساسي، بدل السكن، بدل النقل، العمولات الثابتة، وأي بدلات أو مزايا عينية منتظمة. <strong>لا يُحسب على أساس الراتب الأساسي فقط — بل على أساس إجمالي ما يتقاضاه العامل بشكل منتظم.</strong>
    </p>

    <h2>متى تُصرف المكافأة؟</h2>
    <p>
      وفقاً للمادة 88 من نظام العمل، إذا انتهت خدمة العامل يجب على صاحب العمل دفع أجره وتصفية حقوقه — بما في ذلك مكافأة نهاية الخدمة — <strong>خلال أسبوع واحد على الأكثر</strong> من تاريخ انتهاء العلاقة العمالية. أما إذا كان العامل هو من أنهى العقد، فيجب صرف مستحقاته خلال أسبوعين.
    </p>

    <h2>أخطاء شائعة في حساب المكافأة</h2>
    <p><strong>1. حساب المكافأة على الراتب الأساسي فقط:</strong> المكافأة تُحسب على الأجر الفعلي (الأساسي + البدلات الثابتة).</p>
    <p><strong>2. صرف المكافأة بشكل دوري أثناء العمل:</strong> بعض أصحاب العمل يدفعون جزءاً من المكافأة شهرياً أو سنوياً. هذا لا يُعفيهم من الالتزام لأن المكافأة تُحسب على الراتب الأخير.</p>
    <p><strong>3. عدم احتساب الأجزاء من السنة:</strong> العامل يستحق مكافأة عن أجزاء السنة بنسبة ما قضاه منها.</p>
    <p><strong>4. الخلط بين الفصل والاستقالة:</strong> نسب الاستحقاق تختلف جذرياً. الفصل = مكافأة كاملة. الاستقالة = حسب المدة.</p>

    <h2>ملخص نسب الاستحقاق</h2>
    <div className="overflow-x-auto">
      <table>
        <thead>
          <tr>
            <th>الحالة</th>
            <th>المدة</th>
            <th>النسبة</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>إنهاء من صاحب العمل</td>
            <td>أي مدة</td>
            <td><strong>المكافأة كاملة</strong></td>
          </tr>
          <tr>
            <td>استقالة</td>
            <td>أقل من سنتين</td>
            <td><strong>لا يستحق</strong></td>
          </tr>
          <tr>
            <td>استقالة</td>
            <td>2 - 5 سنوات</td>
            <td><strong>ثلث المكافأة</strong></td>
          </tr>
          <tr>
            <td>استقالة</td>
            <td>5 - 10 سنوات</td>
            <td><strong>ثلثا المكافأة</strong></td>
          </tr>
          <tr>
            <td>استقالة</td>
            <td>أكثر من 10 سنوات</td>
            <td><strong>المكافأة كاملة</strong></td>
          </tr>
          <tr>
            <td>زواج/إنجاب (المرأة)</td>
            <td>أي مدة</td>
            <td><strong>المكافأة كاملة</strong></td>
          </tr>
          <tr>
            <td>قوة قاهرة</td>
            <td>أي مدة</td>
            <td><strong>المكافأة كاملة</strong></td>
          </tr>
        </tbody>
      </table>
    </div>

    <h2>المواد النظامية المرجعية</h2>
    <p><strong>المادة 80:</strong> حالات فصل العامل بدون مكافأة أو تعويض</p>
    <p><strong>المادة 84:</strong> طريقة احتساب مكافأة نهاية الخدمة</p>
    <p><strong>المادة 85:</strong> نسب الاستحقاق عند الاستقالة</p>
    <p><strong>المادة 86:</strong> جواز الاتفاق على عدم احتساب مبالغ معينة ضمن الأجر</p>
    <p><strong>المادة 87:</strong> استحقاق المكافأة كاملة عند القوة القاهرة أو استقالة المرأة بسبب الزواج/الإنجاب</p>
    <p><strong>المادة 88:</strong> مواعيد تصفية حقوق العامل بعد انتهاء الخدمة</p>

    {/* CTA Box */}
    <div className="my-12 p-8 rounded-2xl bg-gradient-to-br from-[#111111]/10 to-[#111111]/5 border border-[#111111]/20 text-center">
      <h3 className="text-xl font-bold text-white mb-3">هل عندك سؤال عن مكافأة نهاية الخدمة أو أي نظام سعودي آخر؟</h3>
      <p className="text-white/70 mb-6">بينة يجيبك فوراً مع ذكر المادة النظامية.</p>
      <Link 
        to="/" 
        className="inline-block px-8 py-3 bg-[#111111] text-black font-bold rounded-lg hover:bg-[#111111] transition-all shadow-[0_0_20px_rgba(0, 0, 0,0.3)] hover:shadow-[0_0_30px_rgba(0, 0, 0,0.4)]"
      >
        جرّب بينة الآن
      </Link>
    </div>

    {/* Disclaimer */}
    <p className="text-sm text-white/40 text-center mt-12 pt-8 border-t border-white/10">
      هذا المحتوى للاطلاع والتوعية القانونية. لا يُعد استشارة قانونية رسمية. يُنصح دائماً بمراجعة محامٍ مرخص للقرارات القانونية المهمة.
    </p>
  </>
);

// Contract Review Blog Post Content
export const ContractReviewContent = () => (
  <>
    <p className="text-lg leading-relaxed">
      توقيع عقد تجاري بدون مراجعة دقيقة هو أحد أكثر الأخطاء تكلفة في بيئة الأعمال السعودية. كثير من النزاعات التجارية التي تصل إلى المحاكم التجارية كان يمكن تجنبها بمراجعة بسيطة قبل التوقيع.
    </p>

    <p>
      سواء كنت توقع عقد توريد، عقد خدمات، عقد شراكة، أو اتفاقية تعاون — هناك 10 بنود حرجة يجب أن تتحقق من وجودها وصياغتها قبل أن تضع توقيعك.
    </p>

    {/* Stats Section */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-8">
      <div className="p-6 rounded-xl bg-[#111111]/5 border border-[#111111]/20 text-center">
        <div className="text-3xl font-bold text-[#111111] mb-2">70%</div>
        <div className="text-sm text-white/60">من النزاعات التجارية سببها صياغة غير واضحة</div>
      </div>
      <div className="p-6 rounded-xl bg-[#111111]/5 border border-[#111111]/20 text-center">
        <div className="text-3xl font-bold text-[#111111] mb-2">10 دقائق</div>
        <div className="text-sm text-white/60">كافية لمراجعة البنود الحرجة</div>
      </div>
      <div className="p-6 rounded-xl bg-[#111111]/5 border border-[#111111]/20 text-center">
        <div className="text-3xl font-bold text-[#111111] mb-2">5 مراحل</div>
        <div className="text-sm text-white/60">تحليل بينة لأي عقد تجاري</div>
      </div>
    </div>

    {/* Clause 1 */}
    <div className="my-8 p-6 rounded-xl bg-white/[0.02] border border-white/10">
      <div className="flex items-start gap-4">
        <span className="flex-shrink-0 w-12 h-12 rounded-full bg-[#111111]/10 flex items-center justify-center text-[#111111] font-bold text-lg">01</span>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-white mb-2">تحديد الأطراف بشكل دقيق</h3>
          <p className="text-white/70 mb-3">كثير من العقود تذكر اسم الشركة فقط بدون السجل التجاري أو اسم الممثل النظامي. هذا يسبب مشاكل عند التنفيذ القضائي لأن المحكمة تحتاج تحديد الشخصية الاعتبارية بدقة.</p>
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-red-500/20 text-red-400 mb-3">خطورة عالية</span>
          <div className="p-4 rounded-lg bg-white/[0.03] text-sm">
            <strong className="text-[#111111]">تأكد من وجود:</strong>
            <span className="text-white/70"> الاسم الكامل للشركة، رقم السجل التجاري، اسم الممثل النظامي وصفته، عنوان المقر الرئيسي.</span>
          </div>
          <p className="text-xs text-white/40 mt-3">المرجع: نظام المعاملات المدنية — أحكام العقد (الباب الأول)</p>
        </div>
      </div>
    </div>

    {/* Clause 2 */}
    <div className="my-8 p-6 rounded-xl bg-white/[0.02] border border-white/10">
      <div className="flex items-start gap-4">
        <span className="flex-shrink-0 w-12 h-12 rounded-full bg-[#111111]/10 flex items-center justify-center text-[#111111] font-bold text-lg">02</span>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-white mb-2">نطاق العمل والالتزامات</h3>
          <p className="text-white/70 mb-3">أكبر مصدر للنزاعات هو الغموض في نطاق العمل. عبارات مثل "تقديم خدمات استشارية" بدون تفصيل تفتح الباب لتفسيرات متناقضة بين الطرفين.</p>
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-red-500/20 text-red-400 mb-3">خطورة عالية</span>
          <div className="p-4 rounded-lg bg-white/[0.03] text-sm">
            <strong className="text-[#111111]">تأكد من وجود:</strong>
            <span className="text-white/70"> وصف تفصيلي للخدمات أو المنتجات، المخرجات المتوقعة بشكل قابل للقياس، المسؤوليات المحددة لكل طرف، ما هو خارج نطاق العمل (الاستثناءات).</span>
          </div>
          <p className="text-xs text-white/40 mt-3">المرجع: نظام المعاملات المدنية — المادة 84 (محل العقد يجب أن يكون معيناً أو قابلاً للتعيين)</p>
        </div>
      </div>
    </div>

    {/* Clause 3 */}
    <div className="my-8 p-6 rounded-xl bg-white/[0.02] border border-white/10">
      <div className="flex items-start gap-4">
        <span className="flex-shrink-0 w-12 h-12 rounded-full bg-[#111111]/10 flex items-center justify-center text-[#111111] font-bold text-lg">03</span>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-white mb-2">المقابل المالي وشروط الدفع</h3>
          <p className="text-white/70 mb-3">عدم تحديد آلية الدفع بوضوح يؤدي إلى تأخيرات وخلافات. يجب أن يكون واضحاً: كم، متى، وكيف يُدفع. والأهم: ماذا يحدث عند التأخير؟</p>
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-red-500/20 text-red-400 mb-3">خطورة عالية</span>
          <div className="p-4 rounded-lg bg-white/[0.03] text-sm">
            <strong className="text-[#111111]">تأكد من وجود:</strong>
            <span className="text-white/70"> إجمالي المبلغ بالأرقام والحروف، جدول الدفعات، مدة السداد بعد الفاتورة، غرامة التأخير في السداد، هل المبلغ شامل ضريبة القيمة المضافة.</span>
          </div>
          <p className="text-xs text-white/40 mt-3">المرجع: نظام المعاملات المدنية — المادة 355 وما بعدها (أحكام الثمن في البيع)</p>
        </div>
      </div>
    </div>

    {/* Clause 4 */}
    <div className="my-8 p-6 rounded-xl bg-white/[0.02] border border-white/10">
      <div className="flex items-start gap-4">
        <span className="flex-shrink-0 w-12 h-12 rounded-full bg-[#111111]/10 flex items-center justify-center text-[#111111] font-bold text-lg">04</span>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-white mb-2">مدة العقد والتجديد</h3>
          <p className="text-white/70 mb-3">بعض العقود تتجدد تلقائياً بدون علم أحد الطرفين، وبعضها ينتهي بدون آلية واضحة للتجديد. كلا السيناريوهين يسبب مشاكل عملية.</p>
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-amber-500/20 text-amber-400 mb-3">خطورة متوسطة</span>
          <div className="p-4 rounded-lg bg-white/[0.03] text-sm">
            <strong className="text-[#111111]">تأكد من وجود:</strong>
            <span className="text-white/70"> تاريخ بداية ونهاية العقد، هل يتجدد تلقائياً أم يحتاج موافقة صريحة، مدة الإشعار لعدم التجديد، شروط الإنهاء المبكر.</span>
          </div>
          <p className="text-xs text-white/40 mt-3">المرجع: نظام المعاملات المدنية — أحكام انتهاء العقد</p>
        </div>
      </div>
    </div>

    {/* Clause 5 */}
    <div className="my-8 p-6 rounded-xl bg-white/[0.02] border border-white/10">
      <div className="flex items-start gap-4">
        <span className="flex-shrink-0 w-12 h-12 rounded-full bg-[#111111]/10 flex items-center justify-center text-[#111111] font-bold text-lg">05</span>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-white mb-2">الشرط الجزائي (غرامة الإخلال)</h3>
          <p className="text-white/70 mb-3">الشرط الجزائي هو سلاح ذو حدين. إذا لم يكن موجوداً، ستحتاج إثبات الضرر الفعلي أمام المحكمة. وإذا كان مبالغاً فيه، يحق للقاضي تخفيضه.</p>
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-red-500/20 text-red-400 mb-3">خطورة عالية</span>
          <div className="p-4 rounded-lg bg-white/[0.03] text-sm">
            <strong className="text-[#111111]">تأكد من وجود:</strong>
            <span className="text-white/70"> مبلغ الشرط الجزائي محدد، الحالات التي يُطبق فيها، هل يُعفي من التنفيذ العيني، هل يحق المطالبة بتعويض إضافي.</span>
          </div>
          <p className="text-xs text-white/40 mt-3">المرجع: نظام المعاملات المدنية — المواد 180-185 (الشرط الجزائي)</p>
        </div>
      </div>
    </div>

    {/* Clause 6 */}
    <div className="my-8 p-6 rounded-xl bg-white/[0.02] border border-white/10">
      <div className="flex items-start gap-4">
        <span className="flex-shrink-0 w-12 h-12 rounded-full bg-[#111111]/10 flex items-center justify-center text-[#111111] font-bold text-lg">06</span>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-white mb-2">السرية وعدم الإفشاء</h3>
          <p className="text-white/70 mb-3">في العقود التجارية، يتم تبادل معلومات حساسة: أسعار، استراتيجيات، بيانات عملاء. بدون بند سرية واضح، لا حماية قانونية لمعلوماتك التجارية.</p>
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-amber-500/20 text-amber-400 mb-3">خطورة متوسطة</span>
          <div className="p-4 rounded-lg bg-white/[0.03] text-sm">
            <strong className="text-[#111111]">تأكد من وجود:</strong>
            <span className="text-white/70"> تعريف واضح للمعلومات السرية، مدة الالتزام بالسرية (3-5 سنوات)، الاستثناءات المشروعة، العقوبة عند الإخلال.</span>
          </div>
          <p className="text-xs text-white/40 mt-3">المرجع: نظام المعاملات المدنية — أحكام الالتزامات التعاقدية</p>
        </div>
      </div>
    </div>

    {/* Clause 7 */}
    <div className="my-8 p-6 rounded-xl bg-white/[0.02] border border-white/10">
      <div className="flex items-start gap-4">
        <span className="flex-shrink-0 w-12 h-12 rounded-full bg-[#111111]/10 flex items-center justify-center text-[#111111] font-bold text-lg">07</span>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-white mb-2">الملكية الفكرية</h3>
          <p className="text-white/70 mb-3">إذا كلّفت شركة بتطوير برنامج أو تصميم أو محتوى — من يملك النتيجة؟ أنت أم هم؟ كثير من العقود لا تجيب على هذا السؤال.</p>
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-red-500/20 text-red-400 mb-3">خطورة عالية</span>
          <div className="p-4 rounded-lg bg-white/[0.03] text-sm">
            <strong className="text-[#111111]">تأكد من وجود:</strong>
            <span className="text-white/70"> من يملك حقوق الملكية الفكرية للمخرجات، متى تنتقل الملكية، حقوق الاستخدام، حماية الملكية الفكرية الموجودة مسبقاً.</span>
          </div>
          <p className="text-xs text-white/40 mt-3">المرجع: نظام حماية حقوق المؤلف — ونظام براءات الاختراع</p>
        </div>
      </div>
    </div>

    {/* Clause 8 */}
    <div className="my-8 p-6 rounded-xl bg-white/[0.02] border border-white/10">
      <div className="flex items-start gap-4">
        <span className="flex-shrink-0 w-12 h-12 rounded-full bg-[#111111]/10 flex items-center justify-center text-[#111111] font-bold text-lg">08</span>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-white mb-2">حدود المسؤولية والتعويض</h3>
          <p className="text-white/70 mb-3">بدون تحديد سقف للمسؤولية، قد تجد نفسك مطالباً بتعويضات تفوق قيمة العقد بمراحل.</p>
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-red-500/20 text-red-400 mb-3">خطورة عالية</span>
          <div className="p-4 rounded-lg bg-white/[0.03] text-sm">
            <strong className="text-[#111111]">تأكد من وجود:</strong>
            <span className="text-white/70"> سقف أعلى للتعويضات، استثناء الأضرار غير المباشرة، التزامات التعويض المتبادلة، هل يشمل الأرباح الفائتة.</span>
          </div>
          <p className="text-xs text-white/40 mt-3">المرجع: نظام المعاملات المدنية — المواد 163-179 (أحكام التعويض)</p>
        </div>
      </div>
    </div>

    {/* Clause 9 */}
    <div className="my-8 p-6 rounded-xl bg-white/[0.02] border border-white/10">
      <div className="flex items-start gap-4">
        <span className="flex-shrink-0 w-12 h-12 rounded-full bg-[#111111]/10 flex items-center justify-center text-[#111111] font-bold text-lg">09</span>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-white mb-2">القوة القاهرة والظروف الاستثنائية</h3>
          <p className="text-white/70 mb-3">جائحة كورونا علّمت الجميع أهمية هذا البند. بدونه، تبقى ملزماً بالتنفيذ حتى في ظروف خارجة عن إرادتك.</p>
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-amber-500/20 text-amber-400 mb-3">خطورة متوسطة</span>
          <div className="p-4 rounded-lg bg-white/[0.03] text-sm">
            <strong className="text-[#111111]">تأكد من وجود:</strong>
            <span className="text-white/70"> تعريف واضح لما يُعتبر قوة قاهرة، إجراءات الإخطار، أثر القوة القاهرة على الالتزامات، مدة التعليق المسموحة.</span>
          </div>
          <p className="text-xs text-white/40 mt-3">المرجع: نظام المعاملات المدنية — المادة 168 (القوة القاهرة) والمادة 172 (الظروف الطارئة)</p>
        </div>
      </div>
    </div>

    {/* Clause 10 */}
    <div className="my-8 p-6 rounded-xl bg-white/[0.02] border border-white/10">
      <div className="flex items-start gap-4">
        <span className="flex-shrink-0 w-12 h-12 rounded-full bg-[#111111]/10 flex items-center justify-center text-[#111111] font-bold text-lg">10</span>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-white mb-2">تسوية النزاعات والاختصاص القضائي</h3>
          <p className="text-white/70 mb-3">أين ستتقاضى إذا حدث خلاف؟ عدم تحديد هذا مسبقاً يعني أن الطرف الآخر قد يختار المكان الأنسب له وليس لك.</p>
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-red-500/20 text-red-400 mb-3">خطورة عالية</span>
          <div className="p-4 rounded-lg bg-white/[0.03] text-sm">
            <strong className="text-[#111111]">تأكد من وجود:</strong>
            <span className="text-white/70"> آلية التسوية الودية أولاً، مدة المفاوضات، جهة الاختصاص (محكمة أو تحكيم)، المدينة، القانون الواجب التطبيق.</span>
          </div>
          <p className="text-xs text-white/40 mt-3">المرجع: نظام المحاكم التجارية — المادة 16 (الاختصاص المكاني) ونظام التحكيم</p>
        </div>
      </div>
    </div>

    {/* Checklist */}
    <div className="my-12 p-8 rounded-2xl bg-white/[0.03] border border-white/10">
      <h3 className="text-xl font-bold text-white mb-6 text-center">قائمة المراجعة السريعة — اطبعها واستخدمها</h3>
      <div className="space-y-3 text-white/80">
        <div className="flex items-center gap-3"><span className="text-white/30">□</span> تحديد الأطراف (اسم، سجل تجاري، ممثل نظامي)</div>
        <div className="flex items-center gap-3"><span className="text-white/30">□</span> نطاق العمل مفصّل وقابل للقياس</div>
        <div className="flex items-center gap-3"><span className="text-white/30">□</span> المقابل المالي واضح مع جدول دفعات</div>
        <div className="flex items-center gap-3"><span className="text-white/30">□</span> مدة العقد وآلية التجديد أو الإنهاء</div>
        <div className="flex items-center gap-3"><span className="text-white/30">□</span> شرط جزائي محدد بالمبلغ والحالات</div>
        <div className="flex items-center gap-3"><span className="text-white/30">□</span> بند سرية مع مدة محددة</div>
        <div className="flex items-center gap-3"><span className="text-white/30">□</span> ملكية فكرية واضحة (من يملك المخرجات)</div>
        <div className="flex items-center gap-3"><span className="text-white/30">□</span> حدود المسؤولية وسقف التعويضات</div>
        <div className="flex items-center gap-3"><span className="text-white/30">□</span> بند القوة القاهرة</div>
        <div className="flex items-center gap-3"><span className="text-white/30">□</span> تسوية النزاعات والاختصاص القضائي</div>
      </div>
    </div>

    <h2>ماذا تفعل إذا وجدت بنداً ناقصاً أو غامضاً؟</h2>
    <p><strong>لا توقّع.</strong> اطلب تعديل الصياغة قبل التوقيع. تعديل بند واحد قبل التوقيع أسهل بمراحل من النزاع عليه بعد التوقيع.</p>
    <p>إذا لم تكن متأكداً من صياغة بند معين أو أردت التحقق من توافقه مع الأنظمة السعودية — يمكنك استخدام بينة لمراجعة العقد مباشرة. ارفع العقد واحصل على تحليل من 5 مراحل يغطي: الملخص، التوافق النظامي، المخاطر، البنود المفقودة، والشرح المبسط.</p>

    <h2>لماذا المراجعة بالذكاء الاصطناعي تختلف عن المراجعة التقليدية؟</h2>
    <p>المراجعة التقليدية تعتمد على خبرة المراجع الشخصية وقد تستغرق أيام. أدوات مثل بينة تفحص العقد بند بند مقابل الأنظمة السعودية وتحدد المخاطر والبنود المفقودة خلال دقيقة واحدة. هذا لا يُغني عن المحامي في القضايا المعقدة، لكنه يمنحك مراجعة أولية سريعة تحدد لك أين تحتاج اهتماماً قبل التوقيع.</p>

    {/* CTA Box */}
    <div className="my-12 p-8 rounded-2xl bg-gradient-to-br from-[#111111]/10 to-[#111111]/5 border border-[#111111]/20 text-center">
      <h3 className="text-xl font-bold text-white mb-3">عندك عقد تجاري وتريد مراجعته قبل التوقيع؟</h3>
      <p className="text-white/70 mb-6">ارفع العقد على بينة واحصل على تحليل شامل من 5 مراحل — المخاطر، البنود المفقودة، التوافق النظامي، والتوصيات.</p>
      <Link 
        to="/" 
        className="inline-block px-8 py-3 bg-[#111111] text-black font-bold rounded-lg hover:bg-[#111111] transition-all shadow-[0_0_20px_rgba(0, 0, 0,0.3)] hover:shadow-[0_0_30px_rgba(0, 0, 0,0.4)]"
      >
        راجع عقدك الآن
      </Link>
    </div>

    {/* Disclaimer */}
    <p className="text-sm text-white/40 text-center mt-12 pt-8 border-t border-white/10">
      هذا المحتوى للاطلاع والتوعية القانونية. لا يُعد استشارة قانونية رسمية. يُنصح دائماً بمراجعة محامٍ مرخص للعقود عالية القيمة أو المعقدة.
    </p>
  </>
);
